import { Controller } from "@hotwired/stimulus";
import "./component.scss";

export default class extends Controller {
  static targets = ["extra", "toggle"];
  static values = { expanded: Boolean, count: Number };

  connect() {}

  toggle() {
    this.expandedValue = !this.expandedValue;
  }

  expandedValueChanged() {
    this.extraTargets.forEach((el) => (el.hidden = !this.expandedValue));

    if (!this.hasToggleTarget) {
      return;
    }

    this.toggleTarget.textContent = this.expandedValue
      ? "Show less"
      : `There are ${this.countValue} more items`;
  }
}
